import { render, staticRenderFns } from "./ProgramsListTable.vue?vue&type=template&id=5f058d30&scoped=true&"
import script from "./ProgramsListTable.vue?vue&type=script&lang=js&"
export * from "./ProgramsListTable.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsListTable.vue?vue&type=style&index=0&id=5f058d30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f058d30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
